import script from "./AgendorPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgendorPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AgendorPanel.vue?vue&type=style&index=0&id=3db0b33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db0b33a"]])

export default __exports__